.socialButton {
  width: 100%;
}
